<ng-container *ngIf="notification.message">
  <mat-icon *ngIf="notification.type" [ngClass]="notification.type" [svgIcon]="iconName"></mat-icon>
  <span>{{ notification.message }}</span>
</ng-container>
